@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@filter-pill-margin-right: 8px;

.filter-bar-styling() {
  padding: 0 4px;
  margin-right: @filter-pill-margin-right;
  color: @actionable-filter-pill--bar--text-color;

  svg {
    fill: @actionable-filter-pill--bar--fill-color;
  }
}

.toggler {
  .filter-bar-styling();

  &.selected {
    border: 1px solid @actionable-filter-pill--toggler--selected--border-color;
    border-radius: 2px;
    background: @actionable-filter-pill--toggler--selected--background-color;
    color: @actionable-filter-pill--toggler--selected--text-color;
    padding: 0 4px 0 8px;
  }
}

.single-pill-wrapper {
  display: flex;
  align-items: center;
}

.tag-pill {
  padding: 5px 3px;
  margin-right: @filter-pill-margin-right;
  min-height: 16px;
}

.ref-wrapper {
  display: inline-block;

  > * {
    display: inherit;
  }
}

.lock-box {
  padding: 5px 7px 5px 5px;
  border: 1px solid @actionable-filter-pill--lock-box--border-color;
  border-radius: 2px;
  background: @actionable-filter-pill--lock-box--background-color;
  color: @actionable-filter-pill--lock-box--text-color;
  font-size: 14px;
  display: flex;
  width: fit-content;
  margin-right: @filter-pill-margin-right;
}

.lock-icon {
  min-width: 10px;
  margin: auto 3px;
  height: 10px;
  width: 10px;
}
